<template>
    <div>
        <v-container fluid grid-list-sm>
            <v-row>
                <v-col cols="12" sm="9">
                    <h3 class="display-1 primary--text">Parts</h3>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="search" label="Search" single-line hide-details />
                </v-col>
                <v-col cols="12" sm="12">
                    <v-data-table :search="search" :loading="isLoading" :headers="headers" :items="parts" class="elevation-1 mt-5" item-key="_id">
                        <template v-slot:item.customer.vrm="{item}">
                            <span v-if="item.customer.vrm" class="vrm"> {{ item.customer.vrm }} </span><span v-else>N/A</span>
                        </template>
                        <template v-slot:item.bookingDate="{item}">
                            <span> {{ item.bookingDate | moment('DD/MM/YYYY') }} </span>
                        </template>
                        <template v-slot:item.orderDate="{item}">
                            <span> {{ item.orderDate | moment('DD/MM/YYYY') }} </span>
                        </template>
                        <template v-slot:item.price="{item}">
                            <span v-if="item.price"> £{{ item.price.toFixed(2) }} </span>
                        </template>
                        <template v-slot:item.isOrdered="{item}">
                            <td><v-checkbox @change="editItem(item)" class="pt-3" v-model="item.isOrdered">{{ item.isOrdered }}</v-checkbox></td>
                        </template>
                        <template v-slot:item.isDelivered="{item}">
                            <td><v-checkbox @change="editItem(item)" class="pt-3" v-model="item.isDelivered">{{ item.isDelivered }}</v-checkbox></td>
                        </template>
                        <template v-slot:item.actions="{item}">
                            <v-icon :disabled="!item.booking" large color="primary" @click="manageBooking(item)">mdi-calendar</v-icon>
                            <v-icon large color="error" @click="deleteItem(item)">mdi-delete</v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {PartsHttp} from "../../http/parts";
    import {EventBus} from "../../EventBus";

    export default {
        name: "Parts",
        data() {
          return {
              headers: [
                  { text: 'Part Name', value: 'name' },
                  { text: 'Customer', value: 'customer.name' },
                  { text: 'Make', value: 'customer.make' },
                  { text: 'VRM', value: 'customer.vrm' },
                  { text: 'Price', value: 'price' },
                  { text: 'Booking Date', value: 'bookingDate' },
                  { text: 'Ordered Date', value: 'orderDate' },
                  { text: 'Is Ordered', value: 'isOrdered' },
                  { text: 'Is Delivered', value: 'isDelivered' },
                  { text: 'Actions', value: 'actions', sortable: false }
              ],
              search: '',
              isLoading: false
          }
        },
        methods: {
            async editItem(part) {
                this.isLoading = true;
                try {
                    await PartsHttp.updatePart(part._id, part);
                    EventBus.$emit('message', {message: 'Part Updated Successfully', type: 'success'});
                    await this.$store.dispatch('parts/setParts');
                } catch (e) {
                    EventBus.$emit('message', {message: e, type: 'error'});
                } finally {
                    this.isLoading = false;
                }
            },
            async deleteItem(part) {
                await this.$store.dispatch('parts/setActivePart', part);
                await this.$store.dispatch('parts/setManageDeletePartDialog', true);
            },
            async manageBooking(item) {
                await this.$store.dispatch('bookings/setActiveBooking', item.booking);
                await this.$store.dispatch('bookings/setManageBookingDialog', true);
            }
        },
        computed: {
            parts: {
                get() {
                    return this.$store.state.parts.parts;
                }
            }
        }
    }
</script>

<style scoped>

</style>
